import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { Divider, TableRow, Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';



//Redux
import { useSelector, useDispatch } from "react-redux";
import { Typography } from '@material-ui/core';


const useStyles = makeStyles({
  table: {
    width: 'auto',
    margin: 'auto'
  },

});




export default function SpanningTable() {
  const classes = useStyles();
  const { user } = useSelector(state => state.auth);
  let loanTerm = user !== null ? user.loanTerm : {};  

  const { calculator: { principal, rate, term, rateTerm, total, amortization } } = useSelector(state => state.data);
    let fd = user && user.fixDeposit < 500 ? Number(principal * loanTerm.fixDeposit).toFixed() : 0;
    let sc = Number(principal * loanTerm.serviceCharge).toFixed();
    let net = Number(principal - fd - sc).toFixed();
  console.log(user);
  return (
    <>
      <Divider style={{border: 'solid 2px'}}/>
  
      <Box sx={{display: 'flex', p: 2}}><Typography className="flex-grow-1">({term}) {rateTerm} Due</Typography><Typography variant="h5" className="text-danger">₱{Number(amortization).toFixed()}</Typography>
          </Box>

          <Divider style={{border: 'solid 2px'}}/>
      <Table className={classes.table} aria-label="spanning table">
        <TableHead>
  
        </TableHead>
        <TableBody>
            <TableRow >
              <TableCell align="left"  colSpan={2}>Principal</TableCell>
              <TableCell align="right"><Typography variant="h5">₱{principal}</Typography></TableCell>
            </TableRow>
            <TableRow >
              <TableCell align="left"  colSpan={2}>Term ({rateTerm})</TableCell>
              <TableCell align="right">{term}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left"  colSpan={2}>Rate ({rateTerm})</TableCell>
              <TableCell align="right">{Number(rate * 100).toFixed(1)}%</TableCell>
            </TableRow>
          <TableRow>
            <TableCell align="left" colSpan={2} >Loan Amount</TableCell>
            <TableCell align="right"><Typography variant="h5">₱{Number(total).toFixed()}</Typography></TableCell>
          </TableRow>
          <TableRow>
          <TableCell rowSpan={1} />
            <TableCell>Fix Deposit</TableCell>
            <TableCell align="right"> - ₱{fd}</TableCell>
          </TableRow>
          <TableRow>
          <TableCell  />
            <TableCell>Service Charge</TableCell>
            <TableCell align="right"> - ₱{sc}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Total</TableCell>
            <TableCell align="right"><Typography variant="h6" className="text-danger">₱{net}</Typography></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
